module.exports = __webpack_public_path__ + "img/cc-logo-long.2d9d5aac.png";